module.exports = __webpack_public_path__ + "static/img/6707_phase_function_Paper_Points.bb52794.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6707_phase_function_Paper_Points.png
// module id = JV2v
// module chunks = 0